import React, { Fragment, useEffect, useState } from 'react';
import Button from '@cmsgov/design-system-core/dist/components/Button/Button';

// Components

import ModalHeader from '../headers/ModalHeader';
import { FormattedMessage } from 'react-intl/dist';

const SessionIdleWarningModal = props => {

    const {
        actions: {
            hideModal
        },
        bottomAnchors: [
            anchor_1,
            anchor_2
        ],
        boundAnchor,
        modal: {
            modalData: {
                logoutUrl,
                popupThresholdValue,
                onHandleReset
            }
        },
        modalHeaderProps,

    } = props;

    const [ counter, setCounter ] = useState(popupThresholdValue);
    const initialRenderTime = Date.now();
    const isTimeOver = counter < 0;


    const getElapsedTime = () => {
        const now = Date.now();
        let elapsedTime = Math.round((now - initialRenderTime) / 1000);
        return elapsedTime;
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCounter(counter - getElapsedTime());
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        if (isTimeOver) {
            setTimeout(() => window.location = logoutUrl, 6000);
        }
    }, [isTimeOver]);

    const handleLeavingApplication = () => {
        sessionStorage.isInImpersonationMode = false;
        sessionStorage.impersonateHHID = '';
        window.location = logoutUrl;
    };

    const handleRestorationClick = () => {
        onHandleReset();
        hideModal();
    };

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...{ ...modalHeaderProps, hideModal: !isTimeOver ? handleRestorationClick : handleLeavingApplication } } />
            </div>
            <div className="gi-modal__body txt-left">
                {
                    !isTimeOver ?
                        <Fragment>
                            <FormattedMessage
                                id='modals.session.will_be_logged_out'
                                values={{
                                    seconds: counter
                                }}
                                tagName='p'
                            />
                            <FormattedMessage
                                id='modals.session.idle_continue'
                                tagName='p'
                            />
                        </Fragment> :
                        <FormattedMessage
                            id='modals.session.have_been_logged_out'
                            tagName='p'
                        />
                }
            </div>
            <div className='gi-modal__controls'>
                {
                    !isTimeOver ?
                        <Button
                            className='usa-button gi-button gi-button__primary'
                            onClick={ handleRestorationClick }
                            inputRef={ boundAnchor(!isTimeOver ? anchor_1 : {}) }
                        >
                            <FormattedMessage id='button.ok'/>
                        </Button> :
                        <Button
                            className='usa-button gi-button gi-button__primary'
                            onClick={ handleLeavingApplication }
                            inputRef={ boundAnchor(isTimeOver ? anchor_2 : {}) }
                        >
                            <FormattedMessage id='button.go_to_login'/>
                        </Button>
                }
            </div>
        </Fragment>
    );
};

export default SessionIdleWarningModal;